// Shared mutable drag state — no React, no re-renders
export const dragState = {
    active: false,
    // Set by the per-frame raycast in Ova.jsx while idle, and by a press that hit
    // the model (a touch has no hover state before it lands). Ova.jsx animates the
    // contact label off any change to it, whichever of the two wrote it.
    hovering: false,
    velocity: 0,
    velocityY: 0,
    lastX: 0,
    lastY: 0,
    pointerId: null,
    rotY: 0,
    rotX: 0,
    dragMomentum: 0,
    modelReady: false,
    // Largest half-extent of the loaded model, written once on load. Drives the
    // responsive camera framing — 0 until the model has parsed.
    modelRadius: 0,
    // Registered by the model once it is in the scene: does this NDC point hit the
    // model right now? The per-frame hover raycast cannot answer for a press on a
    // touch device, because a finger has no hover position before it lands.
    hitTest: null,
    // Pointer NDC — always updated by onPointerMove on the drag div (even outside drag).
    // Used for per-frame raycast hover detection inside Canvas.
    ndcX: 0,
    ndcY: -9, // offscreen default — no false hover on load
};
